<template>
  <div class="kaer-image">
    <img :src="src" class="kaer-image" alt="" @click="jump">
  </div>
</template>

<script>
import { openUrl } from '@/utils/utils';
import { uploadData } from '@/utils/uploadData';
import { env } from '@zyf2e/adapt';

export default {
  name: 'kaer-image',
  props: {
    componentId: String,
    index: {
      type: Number,
      default: 0
    },
    clickTrackId: {
      type: String,
      required: true
    },
    src: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    appUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    jump() {
      let url = this.url
      if (env.inAPP && this.appUrl) url = this.appUrl

      if (url) {
        openUrl(url);
        uploadData(this.clickTrackId, 'event', { url, src: this.src, index: this.index, kaerComponentId: this.componentId });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.kaer-image {
  width: 100%;
  font-size: 0;
}
</style>
